module.exports = __webpack_public_path__ + "img/jifen1.ae7814df.png";